import Vue from 'vue'
import VueRouter from 'vue-router'
import vuetify from '../plugins/vuetify';
import utility from '../ctUtility';
import constants from '@/ctConstants.js';

import ctLandingLogin from '@/views/ctLandingLogin.vue'
import ctLandingSwicth from '@/views/ctLandingSwicth.vue'
import ctPageNotFoundComponent from '@/views/ctPageNotFound.vue'

import ctAppGuiOrganizations from '@/views/appgui/ctOrganizations.vue'
import ctAppGuiOrganization from '@/views/appgui/ctOrganization.vue'
import ctAppGuiMap from '@/views/appgui/ctMap.vue'

import ctAppCommercialeOrganizations from '@/views/appcommerciale/ctOrganizations.vue'
import ctAppCommercialeOrganization from  '@/views/appcommerciale/ctOrganization.vue'
import ctAppCommercialeProject from '@/views/appcommerciale/ctProject.vue'

import ctAppAdminOrganizations from '@/views/appadmin/ctOrganizations.vue'
import ctAppAdminOrganization from '@/views/appadmin/ctOrganization.vue'
import ctAppAdminSite from '@/views/appadmin/ctSite.vue'
import ctAppAdminMap from '@/views/appadmin/ctMap.vue'


Vue.use(VueRouter);
Vue.use(vuetify);
Vue.use(utility);
// LE VARIABILI IN CONSTANTS A VOLTE in beforeEach non le trovo valorizzate meglio non usarle qui

//=== MAPPA DI ROUTING
const routes = [
  { path: '/', name:'landing', component: ctLandingLogin },
  { path: '/notFound', name:'404',  component: ctPageNotFoundComponent },
  { path: '/apps', name:'apps', component: ctLandingSwicth, meta: {requiresAuth: true} },
  
  { path: '/appgui', name:'appGuiLanding', component: ctAppGuiOrganizations, meta: {requiresAuth: true}},
  { path: '/appgui/organizations', name: 'ctAppGuiOrganizations', component: ctAppGuiOrganizations, meta: {requiresAuth: true}},
  { path: '/appgui/organization/:orgId', name: 'ctAppGuiOrganization', component: ctAppGuiOrganization, meta: {requiresAuth: true}},
  { path: '/appgui/map/:orgId/:siteid/:mapid', name:'appGuiMap', component: ctAppGuiMap, meta: {requiresAuth: true}},
 
  { path: '/appcommerciale', name:'appCommercialeLanding', component: ctAppCommercialeOrganizations, meta: {requiresAuth: true}},
  { path: '/appcommerciale/organizations', name: 'appCommercialeOrganizations', component: ctAppCommercialeOrganizations, meta: {requiresAuth: true}},
  { path: '/appcommerciale/organization/:orgId', name:'appCommercialeOrganization', component: ctAppCommercialeOrganization, meta: {requiresAuth: true}},
  { path: '/appcommerciale/project/:orgId/:prjId', name:'appCommercialeProject', component: ctAppCommercialeProject, meta: {requiresAuth: true}},
  
  { path: '/appadmin', name:'appAdminLanding', component: ctAppAdminOrganizations, meta: {requiresAuth: true}},
  { path: '/appadmin/organizations', name: 'appAdminOrganizations', component: ctAppAdminOrganizations, meta: {requiresAuth: true}},
  { path: '/appadmin/organization/:orgId', name: 'appAdminOrganization', component: ctAppAdminOrganization, meta: {requiresAuth: true}},
  { path: '/appadmin/site/:orgId/:siteid', name:'appAdminSite', component: ctAppAdminSite, meta: {requiresAuth: true}},
  { path: '/appadmin/map/:orgId/:siteid/:mapid', name:'appAdminMap', component: ctAppAdminMap, meta: {requiresAuth: true}},
]

//=== OGGETTO ROUTER
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//=== QUESTO METODO VIENE INVOCATO AD OGNI CAMBIO DI ROUTING
router.beforeEach((to, from, next) => {
  if (!to.matched.length) 
  {
    //=== DESTINAZIONE NON TROVATA
    // VADO ALLA PAGINA NOT FOUND
    next('/notFound');
  } 
  else 
  {
    //== SETTING THEMA VUETIFY
    var topath = to.path;
    vuetify.framework.theme.isDark = false;
    /*
    if(topath.includes("/appcommerciale") || topath.includes("/appadmin")){
      vuetify.framework.theme.isDark = false;
    }  else {
      vuetify.framework.theme.isDark = true;
    } 
    */ 
    
    //=== FLAG SE PAGINA PROTETTA O MENO
    //var isToProtected = protectedPagesName.includes(to.name);
    var isToProtected = false;
    if(to.meta.requiresAuth == true){
        isToProtected = to.meta.requiresAuth;
    }

    //=== RECUPERO UTENTE
    //console.log("USER ===");
    var user2check = utility.methods.getUser();
    //console.log(user2check);

    if( utility.methods.isEmptyObj(user2check) && isToProtected)
    {  
      //=== UTENTE NON VALIDO E PAGINA DI DESTINAZIONE PROTETTA
      // REDIRECT TO LOGIN
      next("/");
    } 
    else 
    {
      //=== BISOGNA TESTARE SE UTENTE HA DIRITTI PER APP
      var checkAuthorizedOnApp = true;
      if(topath.includes("/appcommerciale"))
      {
        checkAuthorizedOnApp =  utility.methods.checkAuthorizedOnApp(user2check, 'a001');
        
      } 
      else if(topath.includes("/appgui"))
      {
        checkAuthorizedOnApp =  utility.methods.checkAuthorizedOnApp(user2check, 'a002');
      } 
      else if(topath.includes("/appadmin"))
      {  
        checkAuthorizedOnApp =  utility.methods.checkAuthorizedOnApp(user2check, 'a003');
      }
      //===
      if(checkAuthorizedOnApp)
      {
        //=== VADO ALLA PAGINA DESIDERATA
        next();
      } 
      else 
      {
        //=== VADO ALLA PAGINA DI SELEZIONE DELLE APPS
        next("/apps");
      }
      
    }
  }
})



export default router
